"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRequest = exports.makeTimedOutAction = exports.RequestProvider = exports.RequestContext = void 0;

var _react = _interopRequireWildcard(require("react"));

var _nicbaseSecurity = require("nicbase-security");

var _sockjsClient = _interopRequireDefault(require("sockjs-client"));

var _uuid = require("uuid");

var _excluded = ["requestId"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var RequestContext = /*#__PURE__*/(0, _react.createContext)(undefined);
exports.RequestContext = RequestContext;

var useRequest = function useRequest() {
  var requestContext = (0, _react.useContext)(RequestContext);

  if (requestContext === undefined) {
    throw Error('useRequest must be used within a RequestProvider');
  }

  return requestContext;
};

exports.useRequest = useRequest;

var makeTimedOutAction = function makeTimedOutAction(action) {
  return {
    type: 'ACTION_TIMEOUT_ERROR',
    headers: {},
    body: {
      action: action
    }
  };
};

exports.makeTimedOutAction = makeTimedOutAction;

var RequestProvider = function RequestProvider(_ref) {
  var socketURL = _ref.socketURL,
      defaultRequestOptions = _ref.defaultRequestOptions,
      children = _ref.children;
  var pendingRequests = (0, _react.useRef)(new Map());

  var _useState = (0, _react.useState)(function () {
    return new _sockjsClient["default"](socketURL);
  }),
      _useState2 = _slicedToArray(_useState, 2),
      socket = _useState2[0],
      setSocket = _useState2[1]; // permanent headers that are used for every request


  var _useState3 = (0, _react.useState)(function () {
    var _defaultRequestOption;

    return (_defaultRequestOption = defaultRequestOptions.headers) !== null && _defaultRequestOption !== void 0 ? _defaultRequestOption : {};
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      requestHeaders = _useState4[0],
      setRequestHeaders = _useState4[1]; // add headers that should be used for every following request


  var addHeaders = (0, _react.useCallback)(function (headers) {
    setRequestHeaders(function (prev) {
      return _objectSpread(_objectSpread({}, prev), headers);
    });
  }, []); // remove existing permanent headers if value is truthy

  var removeHeaders = (0, _react.useCallback)(function (headersToRemove) {
    // check which headers should be removed
    var removableHeaders = Object.entries(headersToRemove) // if key is truthy, add header for removal
    .filter(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
          shouldBeRemoved = _ref3[1];

      return shouldBeRemoved;
    }).map(function (_ref4) {
      var _ref5 = _slicedToArray(_ref4, 1),
          headerKey = _ref5[0];

      return headerKey;
    }); // filter and update existing headers

    setRequestHeaders(function (currentHeaders) {
      return Object.keys(currentHeaders).filter(function (existingHeader) {
        return !removableHeaders.includes(existingHeader);
      }).reduce(function (result, headerKey) {
        var nextResult = result;
        nextResult[headerKey] = currentHeaders[headerKey];
        return nextResult;
      }, {});
    });
  }, []); // setup websocket

  (0, _react.useEffect)(function () {
    var messageListener = function messageListener(messageEvent) {
      var decodedMessage = JSON.parse(messageEvent.data);

      var _ref6 = decodedMessage !== null && decodedMessage !== void 0 ? decodedMessage : {},
          _ref6$headers = _ref6.headers,
          _ref6$headers$request = _ref6$headers.requestId,
          requestId = _ref6$headers$request === void 0 ? null : _ref6$headers$request,
          headers = _objectWithoutProperties(_ref6$headers, _excluded),
          type = _ref6.type; // construct response without requestId


      var response = _objectSpread(_objectSpread({}, decodedMessage), {}, {
        headers: headers
      }); // get requestHandler (pending promise) for requestId and resolve or reject based on action type


      var requestHandler = pendingRequests.current.get(requestId);

      if (requestHandler) {
        if (type.endsWith('_SUCCESS')) {
          requestHandler.resolve(response);
        }

        if (type.endsWith('_ERROR')) {
          requestHandler.reject(response);
        }

        pendingRequests.current["delete"](requestId);
      }
    };

    socket.addEventListener('message', messageListener);
    return function () {
      socket.removeEventListener('message', messageListener);
    };
  }, [socket]); // reconnect socket

  var reconnectSocket = (0, _react.useCallback)(function () {
    // only create new socket if old is already closed
    if (socket.readyState === 3) {
      // create new weboscket instances
      setSocket(new _sockjsClient["default"](socketURL));
    }
  }, [socket, socketURL]);
  var request = (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(action) {
      var _auth$getAccessToken;

      var options,
          requestId,
          oauthToken,
          enhancedAction,
          timeoutId,
          timeoutPromise,
          requestPromise,
          _args = arguments;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 1 && _args[1] !== undefined ? _args[1] : defaultRequestOptions;
              // create unique id for request
              requestId = (0, _uuid.v4)();
              oauthToken = (_auth$getAccessToken = _nicbaseSecurity.auth.getAccessToken()) !== null && _auth$getAccessToken !== void 0 ? _auth$getAccessToken : undefined;
              enhancedAction = _objectSpread(_objectSpread({}, action), {}, {
                headers: _objectSpread(_objectSpread(_objectSpread({
                  oauthToken: oauthToken
                }, requestHeaders), action.headers), {}, {
                  requestId: requestId
                })
              }); // create timeout promise that lets the request fail if BE responds too late/never to make sure all promises are fulfilled at some time

              timeoutPromise = new Promise(function (_, reject) {
                // save timeout id, so it can be cleared if success is faster
                timeoutId = setTimeout(function () {
                  reject(makeTimedOutAction(action));
                }, options.timeout);
              });
              requestPromise = new Promise(function (resolve, reject) {
                // save promise for later resolve/reject
                pendingRequests.current.set(requestId, {
                  resolve: resolve,
                  reject: reject
                });

                if (socket.readyState === 1) {
                  socket.send(JSON.stringify(enhancedAction));
                }
              });
              return _context.abrupt("return", Promise.race([timeoutPromise, requestPromise]).then(function (response) {
                // clear timeout if successful response was faster
                clearTimeout(timeoutId);
                return response;
              }));

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref7.apply(this, arguments);
    };
  }(), [defaultRequestOptions, requestHeaders, socket]);
  var isImpersonated = Object.keys(requestHeaders).includes('impersonationId');
  var contextValue = (0, _react.useMemo)(function () {
    return {
      request: request,
      reconnect: reconnectSocket,
      socket: socket,
      addHeaders: addHeaders,
      removeHeaders: removeHeaders,
      headers: requestHeaders,
      isImpersonated: isImpersonated
    };
  }, [request, reconnectSocket, socket, addHeaders, removeHeaders, requestHeaders, isImpersonated]);
  return /*#__PURE__*/_react["default"].createElement(RequestContext.Provider, {
    value: contextValue
  }, children);
};

exports.RequestProvider = RequestProvider;
RequestProvider.defaultProps = {
  children: null,
  defaultRequestOptions: {
    timeout: 30000,
    headers: {}
  }
};